import React from 'react';

import { FontSize } from '../../../typings/design-tokens';
import { makeClassNames } from '../../../utils/styles';
import { IIcon } from '../../atoms/icons/icon';
import IconRedCardWithCircle from '../../atoms/icons/icon-red-card-with-circle';
import IconYellowCardWithCircle from '../../atoms/icons/icon-yellow-card-with-circle';
import Text from '../../atoms/text/text';

import './player-card-stat.scss';

export type IconType = 'red-card' | 'yellow-card';

const TITLE_FONT_SIZE: FontSize = '14';
const VALUE_TWO_FONT_SIZE: FontSize = '18';
const VALUE_FONT_SIZE: FontSize = '42';

export interface IPlayerCardStat {
  title: string;
  value: number;
  iconType?: IconType;
  rightValue?: string;
}

const props: IIcon = {
  size: 'small',
};

const classNames = () =>
  makeClassNames({
    wrapper: 'player-card-stat__wrapper',
    title: 'player-card-stat__title',
    value: 'player-card-stat__value',
    valueTwo: 'player-card-stat__value-two',
  });

const getSvgs = () => {
  return {
    'red-card': <IconRedCardWithCircle {...props} />,
    'yellow-card': <IconYellowCardWithCircle {...props} />,
  };
};

const PlayerCardStat = ({ title, value, iconType, rightValue }: IPlayerCardStat) => {
  const cn = classNames();
  const svg = getSvgs();

  return (
    <div className={cn.wrapper}>
      <div className={cn.title}>
        <Text color="blue" fontSize={TITLE_FONT_SIZE} fontWeight="500">
          {title}
        </Text>
      </div>
      <div className={cn.value}>
        {iconType && svg[iconType]}
        <Text color="blue" fontSize={VALUE_FONT_SIZE} fontWeight="500">
          {value}
        </Text>
        {rightValue && (
          <Text color="blue" className={cn.valueTwo} fontSize={VALUE_TWO_FONT_SIZE} fontWeight="500">
            {rightValue}
          </Text>
        )}
      </div>
    </div>
  );
};

export default PlayerCardStat;
